import { createSelector } from 'reselect';
import moment from 'moment';

export const getUsers = (state) => state.messages.users;
export const getMessages = (state) => state.messages.messages;
export const getCurrentUserIndex = (state) => state.messages.currentUser;
export const getSendInputActive = (state) => state.messages.sendInputActive;

export const getUserId = createSelector(
  [getUsers, getCurrentUserIndex],
  (users, index) => users[index].user.user_id
);

const formatDate = (date) => new moment(date).format('MMM Do');
const formatTime = (date) => new moment(date).format('h:mmA UTC');
const formatType = {
  sms: 'SMS',
  email: 'Email',
  notification: 'Push Notification'
};

export const getThreadList = createSelector([getUsers], (threads) =>
  threads.map(
    ({
      type,
      created_at,
      user: {
        first_name,
        last_name,
        user_id,
        company: { name: client }
      }
    }) => ({
      date: formatDate(created_at),
      time: formatTime(created_at),
      type: formatType[type],
      user: `${first_name} ${last_name}`,
      client,
      user_id
    })
  )
);

export const getMessageList = createSelector([getMessages], (messages) =>
  messages.map(({ created_at, type, message }) => ({
    date: `${formatDate(created_at)} ${formatTime(created_at)}`,
    type: formatType[type],
    message
  }))
);



// WEBPACK FOOTER //
// ./src/actions/communication/messages/selectors.js